module.exports = __webpack_public_path__ + "img/loading2.78e826ca.gif";